import { deployCardImage } from "../images";

export const deployTitle = "Launch Faster, With Confidence";
export const deploySubTitle =
  "Offload routine tasks to Al agents designed to think and act like real engineers using cloud platforms on your behalf.";

export const deployCards = [
  {
    title: "Dedicated Agent Workspace",
    subTitle:
      "An isolated virtual computer that gives AI the same capabilities as a DevOps engineer working on your systems remotely.",
    image: deployCardImage.agentWorkspace,
  },
  {
    title: "Cloud environment context",
    subTitle:
      "Pasoma agents make decisions with an awareness of your infrastructure on AWS and Azure or Google Cloud.",
    image: deployCardImage.cloudContext,
  },
  {
    title: "System Design",
    subTitle:
      "Get help on software architecture, infrastructure requirements, and scaling strategies with insights based to your specific application.",
    image: deployCardImage.systemDesign,
  },
];

// Moinotirng section
export const monitorTitle = "Realtime Agents Watching Your App";
export const monitorSubTitle =
  "Pasoma monitors your production systems, catches issues early, and fixes problems before they become outages.";

export const monitorCards = [
  {
    title: "Proactive Incident Detection",
    subTitle:
      "Continuous logs and metrics analysis that help you filter through the noise and quickly spot issues.",
  },
  {
    title: "Auto fixes & Recovery",
    subTitle:
      "Resolve issues as they occur while keeping you in the loop, from restarting services to applying safe rollbacks.",
  },
  {
    title: "Predictive Auto-scaling",
    subTitle:
      "Adjust capacity in traffic surges so your app stays reliable under load.",
  },
  {
    title: "Integrations and Setup",
    subTitle:
      "Self integration with Sentry, Datadog, PostHog, and PagerDuty for comprehensive monitoring coverage.",
  },
  {
    title: "Cost Reduction Analysis",
    subTitle:
      "Identify opportunities to reduce your infrastructure costs based on daily usage metrics.",
  },
];

// CLI section
export const CliTitle = "An AI DevOps assistant in your terminal";
export const CliSubTitle =
  "A terminal agent that uses existing CLI tools. It can read your code, understand your infrastructure, and execute necessary commands to get things done.";

export const CliCards = [
  {
    title: "Prompt to command",
    subTitle:
      "Describe what you want to accomplish and let AI translate it into the exact commands needed.",
  },
  {
    title: "Available anywhere",
    subTitle:
      "Works across all your environments – local development, staging, and production systems.",
  },
  {
    title: "Codebase context aware",
    subTitle:
      "Understands your project structure, dependencies, and configuration to provide relevant suggestions.",
  },
];
